// extracted by mini-css-extract-plugin
export default {"heading":"signin_heading__OVnIf","div":"signin_div__UdIpm","Div":"signin_Div__4PVJm","form":"signin_form__VCooR","input":"signin_input__owr0D","button":"signin_button__XIcfy"};